<script>

  export default {
    computed: {
      defaultActive() {
        return '/'
      }
    },
    methods: {
      changePwd() {
        this.$router.push({path: '/changepwd'})
      },
      logout() {
        this.$store.commit('logout');
        this.$router.push({path: '/login'})
      }
    },
    data() {
      return {
        user_name: this.$store.state.home.user_obj.name ? this.$store.state.home.user_obj.name : '',
        siderMenuList: this.$store.state.home.menu_list ? this.$store.state.home.menu_list : []
      }
    }
  }
</script>

<template>
  <div class="layout">
    <!-- 左侧菜单 -->
    <div class="sidebar" style="width: 160px;">
      <div class="logo_wrapper">
        <img src="../assets/images/logo.png" alt="logo" style="width: 90px;">
      </div>
      <el-menu
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#3793FF"
        class="menu_wrapper"
        router
        unique-opened
        :default-active="$route.path">
        <template v-for="(item, index) in siderMenuList">
          <el-menu-item class="menu_item" :index="item.url" :key="index">
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <!-- 顶部菜单 -->
    <div class="top_bar">
      <div class="title">欢迎使用碧源水费系统</div>
      <div class="user">
        <el-dropdown size="large">
          <span class="el-dropdown-link">
            {{ user_name }} <i class="iconfont icon-UserService"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePwd"><i class="iconfont icon-rizhichakan"></i>修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i class="iconfont icon-dianyuan"></i>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 中心内容 -->
    <div class="content_wrapper">
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../assets/styles/variable';

  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: $siderbarWidth;
    background-color: $siderbarBackgroundColor;

    .logo_wrapper {
      height: 79px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #DCDCDC;
    }

    .menu_wrapper {
      position: absolute;
      top: 80px;
      bottom: 0;
      width: 100%;
      transition: all 0.3s ease-in-out;

      .menu_item {
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: left;
        font-size: 15px;
        color: #fff;
        // font-weight: bold;
      }
    }
  }

  .top_bar {
    position: fixed;
    left: $siderbarWidth;
    right: 0;
    top: 0;
    height: $topbarHeight;
    line-height: $topbarHeight;
    background-color: $topbarBackgroundColor;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);

    .title {
      float: left;
      margin-left: 12px;
      font-weight: bold;
      font-size: 16px;
      color: $blackTextColor;
    }

    .user {
      float: right;
      margin-right: 15px;
      font-size: 14px;
      color: $blackTextColor;
    }
  }

  .content_wrapper {
    position: fixed;
    left: $siderbarWidth;
    right: 0;
    top: $topbarHeight + 3px;
    bottom: 0;
    background-color: $centerBackgroundColor;

    .content {
      position: relative;
      background-color: white;
      margin: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/Layout.vue